import { sanitizePath } from "../../../utils/sanitizePath";
import { s3 } from "./AwsS3";

type Props = {
  file: any;
  userId?: string;
  folderName: string;
  caseId?: string;
  inmateName?: string;
};

/**
 * Uploads an image to AWS S3.
 * @component uploadImageToS3
 * @author Sanjay
 *
 */

// export const uploadImageToS3 = async ({ file, userId, folderName }: Props) => {
//   const params = {
//     Bucket: `${process.env.REACT_APP_AWS_BUCKET_NAME}/${folderName}`,
//     Key: `${userId}/${file.name}`,
//     ContentType: file.type,
//     Body: file,
//   };

//   try {
//     const data = await s3.upload(params).promise();
//     return data;
//   } catch (err: any) {
//     throw new Error(`Upload failed: ${err.message}`);
//   }
// };

const ALLOWED_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/zip",
  "application/x-zip-compressed",
  "video/mp4",
  "video/webm",
  "video/avi",
  "video/mkv",
  "audio/mpeg",
  "text/csv",
  "text/plain",
];

const ALLOWED_EXTENSIONS = [
  "jpg", "jpeg", "png", "gif", "webp",
  "pdf",
  "doc", "docx",
  "xls", "xlsx",
  "zip",
  "mp4", "webm", "avi", "mkv",
  "mp3",
  "csv", "txt",
];

const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50 MB

const validateFile = (file: any): void => {
  if (!file) {
    throw new Error("No file provided");
  }
  if (!ALLOWED_MIME_TYPES.includes(file.type)) {
    throw new Error(`File type "${file.type}" is not allowed`);
  }
  if (file.size > MAX_FILE_SIZE) {
    throw new Error("File size exceeds the 50 MB limit");
  }
  const ext = file.name?.split(".")?.pop()?.toLowerCase();
  if (!ext || !ALLOWED_EXTENSIONS.includes(ext)) {
    throw new Error(`File extension ".${ext}" is not allowed`);
  }
};

//Here
export const uploadImageToS3 = async ({
  file,
  userId,
  caseId,
  inmateName,
  folderName,
}: any) => {
  validateFile(file);

  const bucketName = process.env.REACT_APP_AWS_BUCKET_NAME;

  if (!bucketName) {
    throw new Error("AWS Bucket name is not defined in environment variables.");
  }

  const sanitizedInmate = sanitizePath(inmateName);
  const sanitizedCaseId = sanitizePath(caseId);
  const sanitizedFileName = sanitizePath(file.name) || "file";

  const params = {
    Bucket: bucketName,
    Key: sanitizedCaseId
      ? `Cases/${sanitizedInmate}-${sanitizedCaseId}/${folderName}/${sanitizedFileName}`
      : `${folderName}/${userId}/${sanitizedFileName}`,
    ContentType: file.type,
    Body: file,
  };

  try {
    const data = await s3.upload(params).promise();
    // const destinationKey = `Cases/${inmateName}-${caseId}/Local Documents/${file.name}`;
    // const uploadDocumentParams = {
    //   Bucket: bucketName,
    //   CopySource: `Cases/${inmateName}-${caseId}/${folderName}/${file.name}`,
    //   Key: destinationKey,
    // };
    // const uploadDocumentParams = {
    //   Bucket: bucketName, // Now we are sure it's a string
    //   Key: caseId ? destinationKey : `${folderName}/${userId}/${file.name}`,
    //   ContentType: file.type,
    //   Body: file,
    // };

    // if (folderName === "Chat Documents" || folderName === "Uploaded Documents")
    // Copy within S3
    // await s3.copyObject(uploadDocumentParams).promise();
    // await s3.upload(uploadDocumentParams).promise();

    return data;
  } catch (err: any) {
    throw new Error(`Upload failed: ${err.message}`);
  }
};

// export const uploadImageToS3 = ({ file, userId, folderName }: Props) => {
//   const params = {
//     Bucket: `coxlaw/${folderName}`,
//     Key: `${userId}/${file.name}`,
//     ContentType: file.type,
//     Body: file,
//   };

//   return new Promise((resolve, reject) => {
//     s3.upload(params, (err: any, data: any) => {
//       if (err) {
//         reject(err);
//       } else {
//         resolve(data);
//       }
//     });
//   });
// };
